export const errors = {
    required: 'Required',
    minLength: 'Email address too short',
    maxLength: 'Email address too long',
    invalid: 'Invalid email address'
};
